export default "__VITE_ASSET__DRZa4oZx__"